import React, {useEffect, useState} from 'react';
import './style.less';
import MainMap from "../../main-page-blocks/map";
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation, Pagination} from "swiper";
import Accordion from "../../main-page-blocks/accordion";
import MainHeader from "../../main-page-blocks/header";
import 'swiper/swiper.less';
import Fancybox from "../../main-page-blocks/fancybox";
import {questService} from "../../../services/guest.services";
import NewsList from "../../main-page-blocks/news-list";
import {notification} from "antd";
import MainFooter from "../../main-page-blocks/footer";
import CookiesMessage from "../../main-page-blocks/cookies";
import Cookies from "js-cookie";
import i18n from "../../../i18n";

export default function MainPage() {
  const [dataLoaded, setDataLoaded] = useState(false);
  const [stats, setStats] = useState(null);
  const [news, setNews] = useState([]);
  const [isOpenPopover, setOpenPopover] =useState(null);

  const getCookies = () => {
    return !!Cookies.get(`cookies`);
  }

  const [isCookiesApproved, setCookiesApproved] = useState(getCookies());

  useEffect(() => {
    if (!dataLoaded) {
      questService
        .getStats()
        .then((response) => {
          setStats(response);
        })
        .catch(() => {
        });
      questService
        .getNewsList()
        .then((response) => {
          setNews(response.news);
        })
        .catch((err) => {
          notification.error({
            message: i18n.t('landing.notification.error'),
            description: err,
          });
        });
      setDataLoaded(true);
    }
  }, [dataLoaded]);

  return <>
    <MainHeader/>
    <main className="content">
      <section className="main" style={{backgroundImage: "url(./img/main-bg.jpg)"}}>
        <div className="main__round main__round1"></div>
        <div className="main__round main__round2"></div>
        <div className="container">
          <div className="main__inner">
            <h1 className="main__title display1">{i18n.t('landing.title')}
            </h1>
            <div className="main__info">
              <div className="main__group">
                <div className="main__group-num">
                  {i18n.t('landing.teasers.1.value')}
                </div>
                <div className="main__group-title text16 bold-weight">
                  {i18n.t('landing.teasers.1.text')}
                </div>
              </div>
              <div className="main__group">
                <div className="main__group-num">
                  {i18n.t('landing.teasers.2.value')}
                </div>
                <div className="main__group-title text16 bold-weight">
                  {i18n.t('landing.teasers.2.text')}
                </div>
              </div>
              <div className="main__group">
                <div className="main__group-num">
                  {i18n.t('landing.teasers.3.value')}
                </div>
                <div className="main__group-title text16 bold-weight">
                  {i18n.t('landing.teasers.3.text')}
                </div>
              </div>
              <div className="main__only text16 bold-weight">
                {i18n.t('landing.teasers.4.text')}
              </div>
            </div>
            <div className="main__nav">
              <a href="/register" className="main__btn m-btn m-btn-primary m-btn-triangle-right">
                <span className="text16 bold-weight">
                    {i18n.t('landing.buttons.partners')}
                </span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="inspect">
        <div className="container">
          <div className="inspect__inner">
            <h2 className="inspect__title display4 gray-text">
              {i18n.t('landing.inspect.title')}
            </h2>
            <p className="inspect__desc display5 gray-middle-text">
              {i18n.t('landing.inspect.levels.title')}
            </p>
            <div className="inspect__items">
              <div className="inspect-card">
                <div className="inspect-card__top">
                  <div className="inspect-card__num">
                    1
                  </div>
                  <div className="inspect-card__info">
                  </div>
                  <div className="inspect-card__line">
                    <img src="./img/round.svg" alt=""/>
                  </div>
                </div>
                <div className="inspect-card__text text14 medium-weight gray-middle-text">
                  {i18n.t('landing.inspect.levels.items.1.title')}
                </div>
              </div>

              <div className="inspect-card">
                <div className="inspect-card__top">
                  <div className="inspect-card__num">
                    2
                  </div>
                  <div className="inspect-card__info">
                    <button className="inspect-card__question medium-weight text13" onClick={() => setOpenPopover("2")}>
                      ?
                    </button>
                    {isOpenPopover === "2" &&
                      <div className="inspect-card__popover">
                        <button className="inspect-card__modal-close" onClick={() => setOpenPopover(null)}>
                          <img src="./img/close.svg" alt=""/>
                        </button>
                        <p className="text14" dangerouslySetInnerHTML={{__html: i18n.t('landing.inspect.levels.items.2.text')}}/>
                      </div>
                    }
                  </div>
                  <div className="inspect-card__line">
                    <img src="./img/round.svg" alt=""/>
                  </div>
                </div>
                <div className="inspect-card__text text14 medium-weight gray-middle-text">
                  {i18n.t('landing.inspect.levels.items.2.title')}
                </div>
              </div>

              <div className="inspect-card">
                <div className="inspect-card__top">
                  <div className="inspect-card__num">
                    3
                  </div>
                  <div className="inspect-card__info">
                    <button className="inspect-card__question medium-weight text13" onClick={() => setOpenPopover("3")}>
                      ?
                    </button>
                    {isOpenPopover === "3" &&
                    <div className="inspect-card__popover">
                      <button className="inspect-card__modal-close" onClick={() => setOpenPopover(null)}>
                        <img src="./img/close.svg" alt=""/>
                      </button>
                      <p className="text14" dangerouslySetInnerHTML={{__html: i18n.t('landing.inspect.levels.items.3.text')}}/>
                    </div>
                    }
                  </div>
                  <div className="inspect-card__line">
                    <img src="./img/round.svg" alt=""/>
                  </div>
                </div>
                <div className="inspect-card__text text14 medium-weight gray-middle-text">
                  {i18n.t('landing.inspect.levels.items.3.title')}
                </div>
              </div>

              <div className="inspect-card">
                <div className="inspect-card__top">
                  <div className="inspect-card__num">
                    4
                  </div>
                  <div className="inspect-card__info">
                    <button className="inspect-card__question medium-weight text13" onClick={() => setOpenPopover("4")}>
                      ?
                    </button>
                    {isOpenPopover === "4" &&
                      <div className="inspect-card__popover">
                        <button className="inspect-card__modal-close" onClick={() => setOpenPopover(null)}>
                          <img src="./img/close.svg" alt=""/>
                        </button>
                        <p className="text14" dangerouslySetInnerHTML={{__html: i18n.t('landing.inspect.levels.items.4.text')}}/>
                      </div>
                    }
                  </div>
                  <div className="inspect-card__line">
                    <img src="./img/round.svg" alt=""/>
                  </div>
                </div>
                <div className="inspect-card__text text14 medium-weight gray-middle-text">
                  {i18n.t('landing.inspect.levels.items.4.title')}
                </div>
              </div>

              <div className="inspect-card">
                <div className="inspect-card__top">
                  <div className="inspect-card__num">
                    5
                  </div>
                  <div className="inspect-card__info">
                    <button className="inspect-card__question medium-weight text13" onClick={() => setOpenPopover("5")}>
                        ?
                    </button>
                    {(isOpenPopover === "5") &&
                      <div className="inspect-card__popover">
                        <button className="inspect-card__modal-close" onClick={()=>setOpenPopover(null)}>
                          <img src="./img/close.svg" alt=""/>
                        </button>
                        <p className="text14" dangerouslySetInnerHTML={{__html: i18n.t('landing.inspect.levels.items.5.text')}}/>
                      </div>
                    }
                  </div>
                  <div className="inspect-card__line">
                    <img src="./img/round.svg" alt=""/>
                  </div>
                </div>
                <div className="inspect-card__text text14 medium-weight gray-middle-text">
                  {i18n.t('landing.inspect.levels.items.5.title')}
                </div>
              </div>

            </div>
            <div className="inspect__media">
              <img src="./img/triangle.svg" alt="" className="inspect__triangle inspect__triangle-desktop"/>
              <img src="./img/triangle2.svg" alt="" className="inspect__triangle inspect__triangle-mob"/>
              <img src="./img/inspect.png" alt="" className="inspect__img"/>
            </div>
          </div>
        </div>
      </section>

      <section className="advantages">
        <div className="container">
          <div className="advantages__grid">
            <div className="advantage-card">
              <h3 className="advantage-card__title display4 gray-text">
                {i18n.t('landing.advantages.items.1.title')}
              </h3>
              <ul className="advantage-card__list m-ul">
                <li>{i18n.t('landing.advantages.items.1.list.1')}</li>
                <li>{i18n.t('landing.advantages.items.1.list.2')}</li>
                <li>{i18n.t('landing.advantages.items.1.list.3')}</li>
              </ul>
              <img src="./img/advantage.webp" alt="" className="advantage-card__img"/>
            </div>

            <div className="advantage-card">
              <h3 className="advantage-card__title display4 gray-text">
                {i18n.t('landing.advantages.items.1.title')}
              </h3>
              <ul className="advantage-card__list m-ul">
                <li>{i18n.t('landing.advantages.items.2.list.1')}</li>
                <li>{i18n.t('landing.advantages.items.2.list.2')}</li>
                <li>{i18n.t('landing.advantages.items.2.list.3')}</li>
              </ul>
              <img src="./img/advantage2.webp" alt="" className="advantage-card__img"/>
            </div>

            <div className="advantage-card">
              <h3 className="advantage-card__title display4 gray-text">
                {i18n.t('landing.advantages.items.3.title')}
              </h3>
              <ul className="advantage-card__list m-ul">
                <li>{i18n.t('landing.advantages.items.3.list.1')}</li>
                <li>{i18n.t('landing.advantages.items.3.list.2')}</li>
                <li>{i18n.t('landing.advantages.items.3.list.3')}</li>
              </ul>
              <img src="./img/advantage3.webp" alt="" className="advantage-card__img"/>
            </div>

          </div>
        </div>
      </section>

      <section className="review">
        <div className="container">
          <div className="review__inner"
               style={{backgroundImage: "linear-gradient(163.85deg, rgba(73, 70, 41, 0.7) 11.23%, rgba(31, 90, 79, 0) 65.24%), url(./img/review.jpg)"}}>
            <div className="review__info">
              <h2 className="review__title display3">
                {i18n.t('landing.review.title')}
              </h2>
              <p className="review__desc text16 semi-bold-weight">
                {i18n.t('landing.review.text')}
              </p>
            </div>
            <Fancybox
              options={{
                Carousel: {
                  infinite: false,
                },
                Toolbar: {
                  display: {
                    left: [],
                    middle: [],
                    right: ["close"],
                  },
                },
              }}
            >
              <a data-fancybox="video-gallery" href="https://www.youtube.com/watch?v=TVTfsOAlBhc"
                 className="video-btn">
                          <span className="video-btn__rounds">
                              <span className="video-btn__round video-btn__round1"></span>
                              <span className="video-btn__round video-btn__round2"></span>
                              <span className="video-btn__round video-btn__round3"></span>
                          </span>
                <img src="./img/play.svg" alt=""/>
              </a>
            </Fancybox>

            {/*<a href="" className="review__pdf m-btn m-btn-primary m-btn-triangle-right">*/}
            {/*  <img src="./img/pdf.svg" alt=""/>*/}
            {/*  <span className="text16 bold-weight">*/}
            {/*                    Скачать презентацию в pdf*/}
            {/*                </span>*/}
            {/*</a>*/}
          </div>
        </div>
      </section>

      <section className="help">
        <div className="help__col"
             style={{backgroundImage: "linear-gradient(67.46deg, rgba(73, 70, 41, 0.54) 0%, rgba(68, 128, 63, 0.9) 100%), url(./img/help.jpg)"}}>
          <div className="help__top">
            <h3 className="display3">
              {i18n.t('landing.help.items.1.title')}
            </h3>
            <p className="text16 semi-bold-weight">
              {i18n.t('landing.help.items.1.text')}
            </p>
          </div>
          <div className="help__bottom">
            <Fancybox
              options={{
                Carousel: {
                  infinite: false,
                },
                Toolbar: {
                  display: {
                    left: [],
                    middle: [],
                    right: ["close"],
                  },
                },
              }}
            >
              <div data-fancybox="" data-src="#for-consignor"
                   className="help__btn m-btn m-btn-primary m-btn-triangle-left">
                <span className="text16 bold-weight">
                    {i18n.t('landing.buttons.forConsignor')}
                </span>
              </div>
            </Fancybox>
          </div>
          <img src="./img/help-decor.svg" alt="" className="help__decor"/>
        </div>

        <div className="help__col"
             style={{backgroundImage: "linear-gradient(247.57deg, rgba(73, 70, 41, 0.9) -0.45%, rgba(68, 128, 63, 0.54) 100%), url(./img/help2.jpg)"}}>
          <div className="help__top">
            <h3 className="display3">
              {i18n.t('landing.help.items.2.title')}
            </h3>
            <p className="text16 semi-bold-weight">
              {i18n.t('landing.help.items.2.text')}
            </p>
          </div>
          <div className="help__bottom">
            <a href="/deliveries/dashboard-deliveries"
               className="help__btn m-btn m-btn-primary m-btn-triangle-right">
            <span className="text16 bold-weight">
                {i18n.t('landing.buttons.dashboard')}
            </span>
            </a>
          </div>
          <img src="./img/help-decor2.svg" alt="" className="help__decor"/>
        </div>

      </section>

      <section className="develop">
        <div className="container">
          <div className="develop__inner">
            <div className="develop__left">
              <div className="develop__badge m-badge">
                <span className="text16 semi-bold-weight green-text">
                    {i18n.t('landing.develop.status')}
                </span>
              </div>
              <h2 className="develop__title display4">
                {i18n.t('landing.develop.title')}
              </h2>
              <p className="develop__desc text20 medium-weight">
                {i18n.t('landing.develop.text')}
              </p>
            </div>
            <div className="develop__right">
              <img src="./img/develop.svg" alt="" className="develop__img"/>
              <img src="./img/develop-decor.svg" alt="" className="develop__decor develop__decor-desktop"/>
              <img src="./img/develop-decor2.svg" alt="" className="develop__decor develop__decor-mob"/>
            </div>
          </div>
        </div>
      </section>

      <section className="tariffs">
        <div className="container">
          <div className="tariffs__top">
            <h2 className="tariffs__title display2">
              <span className="custom-line">{i18n.t('landing.tariffs.title.1')}</span> {i18n.t('landing.tariffs.title.2')}
            </h2>
            <div className="tariffs__badge m-badge">
              <span className="text16 semi-bold-weight">
                  {i18n.t('landing.tariffs.text.1')}
              </span>
            </div>
          </div>
          <div className="tariffs__grid">
            <div className="tariff-card">
              <div className="tariff-card__title display5">
                {i18n.t('landing.tariffs.items.1.description')}
              </div>
              <div className="tariff-card__title display5">
                {i18n.t('landing.tariffs.items.1.price')}
              </div>
              <div>
                {i18n.t('landing.tariffs.items.1.payment')}
              </div>
              <div className="tariff-card__items">
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.1.futures.1')}
                </div>
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.1.futures.2')}
                </div>
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.1.futures.3')}
                </div>
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.1.futures.4')}
                </div>
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.1.futures.5')}
                </div>
                <div className="tariff-card__item _disabled">
                  {i18n.t('landing.tariffs.items.1.futures.6')}
                </div>
                <div className="tariff-card__item _disabled">
                  {i18n.t('landing.tariffs.items.1.futures.7')}
                </div>
                <div className="tariff-card__item _disabled">
                  {i18n.t('landing.tariffs.items.1.futures.8')}
                </div>
                <div className="tariff-card__item _disabled">
                  {i18n.t('landing.tariffs.items.1.futures.9')}
                </div>
                <div className="tariff-card__item _disabled">
                  {i18n.t('landing.tariffs.items.1.futures.10')}
                </div>
              </div>
              <a href="/register"
                 className="tariff-card__btn m-btn m-btn-primary m-btn-triangle-right">
                <span className="text16 bold-weight">
                    {i18n.t('landing.buttons.start')}
                </span>
              </a>
            </div>

            <div className="tariff-card">
              <div className="tariff-card__title display5">
                {i18n.t('landing.tariffs.items.2.description')}
              </div>
              <div className="tariff-card__title display5">
                {i18n.t('landing.tariffs.items.2.price')}
              </div>
              <div>
                {i18n.t('landing.tariffs.items.2.payment')}
              </div>
              <div className="tariff-card__items">
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.2.futures.1')}
                </div>
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.2.futures.2')}
                </div>
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.2.futures.3')}
                </div>
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.2.futures.4')}
                </div>
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.2.futures.5')}
                </div>
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.2.futures.6')}
                </div>
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.2.futures.7')}
                </div>
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.2.futures.8')}
                </div>
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.2.futures.9')}
                </div>
                <div className="tariff-card__item _disabled">
                  {i18n.t('landing.tariffs.items.2.futures.10')}
                </div>
              </div>
              <a href="/register"
                 className="tariff-card__btn m-btn m-btn-primary m-btn-triangle-right">
                <span className="text16 bold-weight">
                    {i18n.t('landing.buttons.start')}
                </span>
              </a>
            </div>

            <div className="tariff-card">
              <div className="tariff-card__title display5">
                {i18n.t('landing.tariffs.items.3.description')}
              </div>
              <div>
                {i18n.t('landing.tariffs.items.3.payment')}
              </div>
              <div>
                {i18n.t('landing.tariffs.items.3.price')}
              </div>
              <div className="tariff-card__items">
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.3.futures.1')}
                </div>
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.3.futures.2')}
                </div>
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.3.futures.3')}
                </div>
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.3.futures.4')}
                </div>
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.3.futures.5')}
                </div>
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.3.futures.6')}
                </div>
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.3.futures.7')}
                </div>
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.3.futures.8')}
                </div>
                <div className="tariff-card__item">
                  {i18n.t('landing.tariffs.items.3.futures.9')}
                </div>
              </div>
              <a href="/register"
                 className="tariff-card__btn m-btn m-btn-primary m-btn-triangle-right">
                <span className="text16 bold-weight">
                    {i18n.t('landing.buttons.start')}
                </span>
              </a>
            </div>

          </div>
        </div>
      </section>

      <section className="how-work">
        <div className="container">
          <h2 className="how-work__title display2">
            {i18n.t('landing.how.title.1')}
            <span className="custom-line"> {i18n.t('landing.how.title.2')}</span>
          </h2>
          <div className="how-work__grid">
            <div className="step-card">
              <div className="step-card__content">
                <div className="step-card__img">
                  <img src="./img/step.svg" alt=""/>
                </div>

                <div className="step-card__top">
                  <div className="step-card__title display4 yellow-text">
                    {i18n.t('landing.how.items.1.title')}
                  </div>
                  <div className="step-card__line">
                    <img src="./img/round.svg" alt=""/>
                  </div>
                </div>

                <div className="step-card__desc display5">
                  {i18n.t('landing.how.items.1.text')}
                </div>
              </div>
              <Fancybox
                options={{
                  Carousel: {
                    infinite: false,
                  },
                  Toolbar: {
                    display: {
                      left: [],
                      middle: [],
                      right: ["close"],
                    },
                  },
                }}
              >
                <a data-fancybox="" href="./img/work/work1.png" className="step-card__content2">
                  <img className="step-card__img2" src="./img/work/work1.png" alt=""/>
                  <img src="./img/zoom.svg" alt="" className="step-card__zoom"/>
                  <div className="step-card__round-wrap">
                    <span className="step-card__round"></span>
                  </div>
                </a>
              </Fancybox>
            </div>

            <div className="step-card">
              <div className="step-card__content">
                <div className="step-card__img">
                  <img src="./img/step2.svg" alt=""/>
                </div>

                <div className="step-card__top">
                  <div className="step-card__title display4 yellow-text">
                    {i18n.t('landing.how.items.2.title')}
                  </div>
                  <div className="step-card__line">
                    <img src="./img/round.svg" alt=""/>
                  </div>
                </div>

                <div className="step-card__desc display5">
                  {i18n.t('landing.how.items.2.text')}
                </div>
              </div>
              <Fancybox
                options={{
                  Carousel: {
                    infinite: false,
                  },
                  Toolbar: {
                    display: {
                      left: [],
                      middle: [],
                      right: ["close"],
                    },
                  },
                }}
              >
                <a data-fancybox="" href="./img/work/work2.png" className="step-card__content2">
                  <img className="step-card__img2" src="./img/work/work2.png" alt=""/>
                  <img src="./img/zoom.svg" alt="" className="step-card__zoom"/>
                  <div className="step-card__round-wrap">
                    <span className="step-card__round"></span>
                  </div>
                </a>
              </Fancybox>
            </div>

            <div className="step-card">
              <div className="step-card__content">
                <div className="step-card__img">
                  <img src="./img/step3.svg" alt=""/>
                </div>

                <div className="step-card__top">
                  <div className="step-card__title display4 yellow-text">
                    {i18n.t('landing.how.items.3.title')}
                  </div>
                  <div className="step-card__line">
                    <img src="./img/round.svg" alt=""/>
                  </div>
                </div>

                <div className="step-card__desc display5">
                  {i18n.t('landing.how.items.3.text')}
                </div>
              </div>
              <Fancybox
                options={{
                  Carousel: {
                    infinite: false,
                  },
                  Toolbar: {
                    display: {
                      left: [],
                      middle: [],
                      right: ["close"],
                    },
                  },
                }}
              >
                <a data-fancybox="" href="./img/work/work3.png" className="step-card__content2">
                  <img className="step-card__img2" src="./img/work/work3.png" alt=""/>
                  <img src="./img/zoom.svg" alt="" className="step-card__zoom"/>
                  <div className="step-card__round-wrap">
                    <span className="step-card__round"></span>
                  </div>
                </a>
              </Fancybox>
            </div>

            <div className="step-card">
              <div className="step-card__content">
                <div className="step-card__img">
                  <img src="./img/step4.svg" alt=""/>
                </div>

                <div className="step-card__top">
                  <div className="step-card__title display4 yellow-text">
                    {i18n.t('landing.how.items.4.title')}
                  </div>
                  <div className="step-card__line">
                    <img src="./img/round.svg" alt=""/>
                  </div>
                </div>

                <div className="step-card__desc display5">
                  {i18n.t('landing.how.items.4.text')}
                </div>
              </div>
              <Fancybox
                options={{
                  Carousel: {
                    infinite: false,
                  },
                  Toolbar: {
                    display: {
                      left: [],
                      middle: [],
                      right: ["close"],
                    },
                  },
                }}
              >
                <a data-fancybox="" href="./img/work/work4.png" className="step-card__content2">
                  <img className="step-card__img2" src="./img/work/work4.png" alt=""/>
                  <img src="./img/zoom.svg" alt="" className="step-card__zoom"/>
                  <div className="step-card__round-wrap">
                    <span className="step-card__round"></span>
                  </div>
                </a>
              </Fancybox>
            </div>

          </div>
        </div>
      </section>

      <section className="routes">
        <h2 className="routes__title display2">
          {i18n.t('landing.routes.title.1')}
          <span className="custom-line"> {i18n.t('landing.routes.title.2')}</span>
        </h2>
        <MainMap/>
      </section>

      <section className="service">
        <div className="container">
          <div className="service__inner">
            <div className="service__left">
              <div className="service__top">
                <h2 className="service__title display2">
                  <span dangerouslySetInnerHTML={{__html: i18n.t('landing.service.title.1')}}/>
                  <span className="custom-line"> {i18n.t('landing.service.title.2')}</span>
                </h2>
                <div className="service__desc text20" dangerouslySetInnerHTML={{__html: i18n.t('landing.service.text')}}/>
              </div>
              <div className="service__hours">
                <img src="./img/clock.png" alt="" className="service__hours-img"/>
                <div className="service__hours-bg"></div>
              </div>
            </div>
            <div className="service__right">
              <div className="service__slider">
                <div className="swiper-container">
                  <Swiper
                    spaceBetween={28}
                    pagination={{
                      type: "fraction",
                      el: '.service .swiper-pagination',
                    }}
                    navigation={{
                      nextEl: '.service .swiper-button-next',
                      prevEl: '.service .swiper-button-prev',
                    }}
                    breakpoints={{
                      320: {
                        spaceBetween: 4,
                      },
                      601: {
                        spaceBetween: 28,
                      }
                    }}
                    modules={[Pagination, Navigation]}
                  >
                    <SwiperSlide>
                      <>
                        <div className="chat">
                          <img src="./img/screen/screen1.jpg" alt=""/>
                        </div>
                        <div className="chat__text text20 bold-weight">
                          {i18n.t('landing.service.slider.1')}
                        </div>
                      </>
                    </SwiperSlide>
                    <SwiperSlide>
                      <>
                        <div className="chat">
                          <img src="./img/screen/screen2.jpg" alt=""/>
                        </div>
                        <div className="chat__text text20 bold-weight">
                          {i18n.t('landing.service.slider.2')}
                        </div>
                      </>
                    </SwiperSlide>
                    <SwiperSlide>
                      <>
                        <div className="chat">
                          <img src="./img/screen/screen3.jpg" alt=""/>
                        </div>
                        <div className="chat__text text20 bold-weight">
                          {i18n.t('landing.service.slider.3')}
                        </div>
                      </>
                    </SwiperSlide>
                    <SwiperSlide>
                      <>
                        <div className="chat">
                          <img src="./img/screen/screen4.jpg" alt=""/>
                        </div>
                        <div className="chat__text text20 bold-weight">
                          {i18n.t('landing.service.slider.4')}
                        </div>
                      </>
                    </SwiperSlide>
                    <SwiperSlide>
                      <>
                        <div className="chat">
                          <img src="./img/screen/screen5.jpg" alt=""/>
                        </div>
                        <div className="chat__text text20 bold-weight">
                          {i18n.t('landing.service.slider.5')}
                        </div>
                      </>
                    </SwiperSlide>
                  </Swiper>

                  <div className="service__nav">
                    <div className="swiper-pagination"></div>
                    <div className="service__buttons">
                      <button className="swiper-button swiper-button-prev m-btn m-btn-primary m-btn-triangle-left">
                        <img src="./img/prev.svg" alt=""/>
                      </button>
                      <button className="swiper-button swiper-button-next m-btn m-btn-primary m-btn-triangle-right">
                        <img src="./img/next.svg" alt=""/>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="qa">
        <div className="container">
          <h2 className="qa__title display2">
            <span className="custom-line">{i18n.t('landing.qa.title.1')} </span>
            {i18n.t('landing.qa.title.2')}
          </h2>
          {<Accordion/>}
        </div>
      </section>

      {news.length > 0 && <NewsList news={news}/>}
    </main>
    <MainFooter/>
    <CookiesMessage isCookiesApproved={isCookiesApproved} setCookiesApproved={setCookiesApproved} />
    <div className="news-modal" id="for-consignor" style={{display: "none", maxWidth: "600px"}}>
      <div className="news-modal__dialog">
        <div className="news-card__date text14"/>
        <h3 className="news-card__title display4">
          {i18n.t('landing.modal.title')}
        </h3>
        <p className="news-card__desc text20">
          {i18n.t('landing.modal.steps.1')}
        </p>
        <p className="news-card__desc text20">
          {i18n.t('landing.modal.steps.2')}
        </p>
        <p className="news-card__desc text20">
          {i18n.t('landing.modal.steps.3')}
        </p>
        <p className="news-card__desc text20">
          {i18n.t('landing.modal.steps.4')}
        </p>
      </div>
    </div>
  </>;
};
